// This line should be edit by building tool to change the commit hash
// in build time, so in general please do not change anything in this file
// or it will break the versioning system
export const COMMIT_HASH = 'f68a94'
